module.exports = __webpack_public_path__ + "img/alicia-busborg.6db9e7cc.png";